// Unhovered photos
import team1 from '../assets/team/t1.png';
import team2 from '../assets/team/t2.png';
import team3 from '../assets/team/t3.png';
import team4 from '../assets/team/t4.png';
import team5 from '../assets/team/t5.png';
import team6 from '../assets/team/t6.png';
import team7 from '../assets/team/t7.png';
import team8 from '../assets/team/t8.png';
import team9 from '../assets/team/t9.png';
import team10 from '../assets/team/t10.png';
import team11 from '../assets/team/t11.png';
import team12 from '../assets/team/t12.png';
import team13 from '../assets/team/t13.png';
import team14 from '../assets/team/t14.png';
import team15 from '../assets/team/t15.png';
import team16 from '../assets/team/t16.png';

// Hovered photos
import teamHovered1 from '../assets/team/v1.png';
import teamHovered2 from '../assets/team/v2.png';
import teamHovered3 from '../assets/team/v3.png';
import teamHovered4 from '../assets/team/v4.png';
import teamHovered5 from '../assets/team/v5.png';
import teamHovered6 from '../assets/team/v6.png';
import teamHovered7 from '../assets/team/v7.png';
import teamHovered8 from '../assets/team/v8.png';
import teamHovered9 from '../assets/team/v9.png';
import teamHovered10 from '../assets/team/v10.png';
import teamHovered11 from '../assets/team/v11.png';
import teamHovered12 from '../assets/team/v12.png';
import teamHovered13 from '../assets/team/v13.png';
import teamHovered14 from '../assets/team/v14.png';
import teamHovered15 from '../assets/team/v15.png';
import teamHovered16 from '../assets/team/v16.png';

const team = {
  hovered: [
    teamHovered1,
    teamHovered2,
    teamHovered3,
    teamHovered4,
    teamHovered5,
    teamHovered6,
    teamHovered7,
    teamHovered8,
    teamHovered9,
    teamHovered10,
    teamHovered11,
    teamHovered12,
    teamHovered13,
    teamHovered14,
    teamHovered15,
    teamHovered16,
  ],
  team: [
    team1,
    team2,
    team3,
    team4,
    team5,
    team6,
    team7,
    team8,
    team9,
    team10,
    team11,
    team12,
    team13,
    team14,
    team15,
    team16,
  ],
  names: [
    'Tribe -> Adin Backovic',
    'Tribe -> Lamija Herenda',
    'Tribe -> Ljiljan Veselinovic',
    'Tribe -> David Wigemark ŠEF',
    'Tribe -> Eldin Herenda',
    'Tribe -> Dana Cazacu',
    'Tribe -> Adam Murray',
    'Tribe -> Ajdin Ahmetovic',
    'Tribe -> Tarik Dzambic',
    'Tribe -> Sead Smailagic',
    'Tribe -> Lejla Omerovic',
    'Tribe -> Alen Omercic',
    'Tribe -> Niaina Sadikovic-Rastimanohatra',
    'Tribe -> About Us',
    'Tribe -> You',
  ],
};

export default team;
